import { createContext, useContext, useState, useCallback } from 'react';

// Centralized chatbot visibility context so multiple triggers (e.g., HomePage CTA button
// and floating action button) reference ONE modal instance. This avoids duplicate state,
// prevents users from opening two overlapping chat interfaces, and ensures consistent
// accessibility semantics (single aria-modal dialog in the DOM at any time).
const ChatbotContext = createContext(null);

export const ChatbotProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openChatbot = useCallback(() => setIsOpen(true), []);
  const closeChatbot = useCallback(() => setIsOpen(false), []);
  const toggleChatbot = useCallback(() => setIsOpen(o => !o), []);

  return (
    <ChatbotContext.Provider value={{ isOpen, openChatbot, closeChatbot, toggleChatbot }}>
      {children}
    </ChatbotContext.Provider>
  );
};

export const useChatbot = () => {
  const ctx = useContext(ChatbotContext);
  if (!ctx) throw new Error('useChatbot must be used within ChatbotProvider');
  return ctx;
};
